import React, {useEffect, useRef} from 'react';
import PropTypes from 'prop-types';
import styles from './HeaderAndFooter.module.scss';
import {Footer, Header, VirtualSidebar, Tabs} from '../../components';
import {Box, Button, Grid, Typography} from '@mui/material';
import WbSunnyOutlinedIcon from '@mui/icons-material/WbSunnyOutlined';
import {styled} from '@mui/material/styles';
import {toggleTheme} from '../../redux/actionCreators/theme';
import {resetFilterTable} from '../../redux/actionCreators/tableFilter';
import {updateUser} from '../../redux/actionCreators/user';
import {updateLastLineItem} from '../../redux/actionCreators/station';
import {connect} from 'react-redux';
import {DARK_MODE, LIGHT_MODE, REDIRECT_URLS} from '../../constants';
import {pxToRem, responsiveFontSizes} from '../../utils/getFontValue';
import {useLocation} from 'react-router-dom';
import { AutoFocusProvider } from '../../contexts';

const CssButton = styled(Button)(({ themeMode }) => ({
	backgroundColor: themeMode === DARK_MODE ? '#ffffff' : '#000',
	color: themeMode === DARK_MODE ? '#000' : '#fff',
	padding: '0.3rem 0.5rem',
	'&:hover': {
		backgroundColor: themeMode === DARK_MODE ? '##ffffff' : '#000',
	},
	fontSize: pxToRem(10),
	fontWeight: '500',
	...responsiveFontSizes({ sm: 10, md: 12, lg: 14 }),
}));


// Removed styled components - now using CSS modules

const mapStateToProps = state => {
	return {
		user: state.user,
		themeMode: state.theme.themeMode,
		allowedOperations: state.operations.allowedOperations,
	};
};

const mapDispatchToProps = dispatch => ({
	toggleTheme: themeMode => dispatch(toggleTheme(themeMode)),
	resetFilterTable: () => dispatch(resetFilterTable()),
	updateUser: (data) => dispatch(updateUser(data)),
	updateLastLineItem: (data) => dispatch(updateLastLineItem(data)),
});

export const HeaderAndFooter = ({
	user,
	themeMode,
	toggleTheme,
	allowedOperations,
	resetFilterTable,
	updateUser,
	updateLastLineItem,
	children,
}) => {
	const scrollableContent = useRef();

	const {pathname} = useLocation();

	const showTabs =
		(pathname === REDIRECT_URLS[allowedOperations[0]] ||
		pathname === REDIRECT_URLS.MAJOR_REPAIR ||
		pathname === REDIRECT_URLS.MAJOR_REPAIR_RECEIVE_PART ||
		pathname === REDIRECT_URLS.MAJOR_REPAIR_RECEIVE_PART_LEGACY ||
		pathname === '/upcoming-line-item' ||
		pathname === '/processed' ||
		pathname === '/processed-line-item' ||
		pathname === '/assembly/receive-part') &&
		pathname !== '/scan-vin';

	const handleToggleTheme = () => {
		const mode = themeMode === DARK_MODE ? LIGHT_MODE : DARK_MODE;
		toggleTheme(mode);
	};

	const keyboardScroll = event => {
		if (event.keyCode === 40) {
			scrollableContent.current.scrollTo({
				behaviour: 'smooth',
				top: scrollableContent.current.scrollTop + 40,
			});
		}
		if (event.keyCode === 38) {
			scrollableContent.current.scrollTo({
				behaviour: 'smooth',
				top: scrollableContent.current.scrollTop - 40,
			});
		}
	};

	useEffect(() => {
		document.addEventListener('keydown', keyboardScroll);

		return () => document.removeEventListener('keydown', keyboardScroll);
	}, []);

	return (
		<AutoFocusProvider>
			<Box className={`${styles.body} ${themeMode === DARK_MODE ? styles.bodyDark : styles.bodyLight}`}>
				<Header 
					resetFilterTable={resetFilterTable}
					updateUser={updateUser}
					updateLastLineItem={updateLastLineItem}
				/>
				<Box className={`${styles.mainContentContainer} ${themeMode === DARK_MODE ? styles.mainContentContainerDark : styles.mainContentContainerLight}`}>
						{showTabs && (
						<Grid
							container
							className={styles.appBar}
							sx={{
								padding: {
									xs: '0.5rem 1.5rem 0.5rem 1.5rem',
									md: '1rem 1.5rem 0.5rem 1.5rem',
								},
							}}
						>
							<Grid
								item
								container
								xs={5}
								alignItems='flex-start'
								justifyContent='flex-start'
							>
								<Tabs />
								
							</Grid>
						</Grid>
					)}
					<Box
						ref={scrollableContent}
						id='scrollable-content'
						className={`${styles.scrollableContent} ${styles.scrollBar}`}
					>
						{children}
					</Box>
				</Box>
				 <VirtualSidebar /> 
				<Footer />
			</Box>
		</AutoFocusProvider>
	);
};

HeaderAndFooter.propTypes = {
	themeMode: PropTypes.string,
	toggleTheme: PropTypes.func,
	showTabs: PropTypes.bool,
	children: PropTypes.any,
};
export default connect(mapStateToProps, mapDispatchToProps)(HeaderAndFooter);
